import type { User } from '@/configs/apis/user';
import type { CreateGroupParams } from '@/configs/apis/groups/interface';
import type {
  ChatMessagePayloadType,
  ChatMessageStatus,
} from '../useChatMessages/types';
import type { Chat, ChatQuery } from '../useChats/types';
import type { chat } from '../../protobuf/protobufs/chat';
import type { useChatMediaCall } from '.';

export type UseChatMediaCallResult = ReturnType<typeof useChatMediaCall>;

export enum ChatMediaGetTokenType {
  SINGLE = 3,
  GROUP = 4,
}

export enum ChatMediaType {
  SINGLE = 1,
  MULTIPLE = 2,
  GROUP = 3,
}

export type GetMediaTokenParams = ChatQuery &
  Partial<Pick<CreateGroupParams, 'related_gid'>> & {
    handlers: {
      sendBefore: (chat: Chat) => ResolveValue<chat.IGetMediaCallTokenRequest>;
    };
  };

export type ChatMediaGetTokenOfCallParams = ChatQuery &
  Partial<Pick<CreateGroupParams, 'related_gid'>>;

export interface ChatMediaGetTokenOfJoinParams extends ChatQuery {
  room_id?: string;
}
export enum CallMemberStatus {
  WAITING = 1, // Waiting
  TALKING = 2, // Ing
}
export enum CallMemberRole {
  HOST = 1, // Host
  NORMAL = 2, // Normal
}
export interface CallMember extends User {
  status?: CallMemberStatus;
  userId: string;
  role?: CallMemberRole;
  inviteUserId?: string;
}
export interface ChatMediaInfo {
  type: ChatMediaType;
  is_busy: CallTokenStatus;
  rtc_token: string;
  room_id: string;
  message_id: string;
  cli_msg_id: string;
  code: string;
  payload_type: ChatMessagePayloadType;
  status: ChatMessageStatus;
  chat: Chat;
  owner_id: string;
  caller: CallMember | null;
  callMembers: CallMember[];
}

export type ChatMediaInfoPartial = Partial<ChatMediaInfo>;

export type ChatMediaInfoMap = MyRecord<ChatMediaInfoPartial>;

export interface ChatMedia {
  openMediaModal: boolean;
  openMediaNotice: boolean;
  mediaModalZoomIn: boolean;
  activatedId: string | undefined;
  chatMediaInfoMap: ChatMediaInfoMap;
}
export enum CallTokenStatus {
  IDLE = 0, // Idle
  BUSY = 1, // Busy line
  COLLINEAR = 2, // Same Line
  ABNORMAL = 3, // Abnormal
}

export enum CallOperateCode {
  SUCCESS = 1,
  SEND_NO_FRIEND = 2,
  RECEIVE_NO_FRIEND = 3,
}

export type GetMediaInfoParams = Pick<ChatMediaInfo, 'room_id'>;

export type MediaCallParams = ChatQuery &
  Pick<ChatMediaInfo, 'payload_type'> &
  Partial<Pick<ChatMediaInfo, 'type' | 'callMembers'>> &
  Partial<Pick<CreateGroupParams, 'related_gid'>>;

export type MediaCallOperateParams = MediaCallParams & Pick<ChatMediaInfo, 'room_id'>;

export type MediaOperateOfJoinParams = Pick<ChatMediaInfo, 'status'> & {
  chatMediaInfo?: ChatMediaInfo;
};

export type MediaSyncInfoParams = Pick<ChatMediaInfo, 'room_id'>;
